"use strict";

angular.module("licensure.services").factory("TGTriggerGroups", [
    "$http",
    "$q",
    "$injector",
    function($http, $q, $injector) {
        var get = function(code, configID) {
            var d = $q.defer();

            $http
                .get(apiLocation + "/api/TGTriggerGroups", {
                    params: {
                        code: code,
                        configID: configID
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        };

        var checkObjectTriggers = function(trigger) {
            var d = $q.defer();

            if (trigger.service != null) {
                trigger.objectTriggers = [];
                var service = $injector.get(trigger.service);
                var method = "get";

                if (trigger.method != null) {
                    method = trigger.method;
                }
                service[method]().then(function(objects) {
                    if (objects != null) {
                        objects.forEach(function(object) {
                            var objectTrigger = angular.copy(trigger);
                            objectTrigger.trigger_object_id = object.id;
                            objectTrigger.trigger_object_name = object.name;
                            objectTrigger.trigger_action_values = [];

                            trigger.trigger_action_values.forEach(function(
                                tav
                            ) {
                                if (tav.trigger_object_id == object.id) {
                                    objectTrigger.trigger_action_values.push(
                                        tav
                                    );
                                }
                            });

                            objectTrigger.previous_actions = angular.copy(
                                objectTrigger.trigger_action_values
                            );
                            trigger.objectTriggers.push(objectTrigger);
                        });
                    }

                    d.resolve();
                });
            } else {
                trigger.previous_actions = angular.copy(
                    trigger.trigger_action_values
                );
                d.resolve();
            }

            return d.promise;
        };

        return {
            get: get,

            getConfiguration: function(code, configID) {
                var d = $q.defer();
                var promises = [];

                get(code, configID).then(function(groups) {
                    groups.forEach(function(group) {
                        group.triggers.forEach(function(trigger) {
                            promises.push(checkObjectTriggers(trigger));
                        });
                    });

                    $q.all(promises).then(function() {
                        d.resolve(groups);
                    }).catch(function (response) {
                        // handle error
                    });
                });

                return d.promise;
            }
        };
    }
]);
